module.exports = __webpack_public_path__ + "images/category_lp/watch/seiko/assessment_achievements/5@2x_b6f476fc403d412c67605a0a9d471e42.png";